import React from 'react';
import { QUALITY_TIERS, QUALITY_LEVELS } from '../../constants/importConstants';

const barColors = {
  4: 'bg-success',
  3: 'bg-info',
  2: 'bg-warning',
  1: 'bg-muted-foreground',
};

/**
 * Horizontal quality progress bar showing tier distribution.
 * @param {object} props
 * @param {number} [props.score] - overall score 1-4 (renders a single bar if provided)
 * @param {object} [props.distribution] - { gold: number, silver: number, bronze: number, estimated: number } percentages
 * @param {string} [props.className]
 * @param {boolean} [props.showLabels=true]
 */
const QualityBar = ({ score, distribution, className = '', showLabels = true }) => {
  if (distribution) {
    const segments = [
      { key: 'gold', level: 4, pct: distribution.gold || 0 },
      { key: 'silver', level: 3, pct: distribution.silver || 0 },
      { key: 'bronze', level: 2, pct: distribution.bronze || 0 },
      { key: 'estimated', level: 1, pct: distribution.estimated || 0 },
    ].filter((s) => s.pct > 0);

    return (
      <div className={className}>
        <div className='flex h-3 rounded-full overflow-hidden bg-muted'>
          {segments.map((seg) => (
            <div
              key={seg.key}
              className={`${barColors[seg.level]} transition-all`}
              style={{ width: `${seg.pct}%` }}
              title={`${QUALITY_TIERS[seg.level]?.label}: ${Math.round(seg.pct)}%`}
            />
          ))}
        </div>
        {showLabels && (
          <div className='flex justify-between mt-1'>
            {segments.map((seg) => (
              <span key={seg.key} className='text-xs text-muted-foreground'>
                {QUALITY_TIERS[seg.level]?.label} {Math.round(seg.pct)}%
              </span>
            ))}
          </div>
        )}
      </div>
    );
  }

  const normalizedScore = Math.max(1, Math.min(4, score || 1));
  const pct = ((normalizedScore - 1) / 3) * 100;
  const level = Math.round(normalizedScore);

  return (
    <div className={className}>
      <div className='flex h-3 rounded-full overflow-hidden bg-muted'>
        <div
          className={`${barColors[level]} transition-all rounded-full`}
          style={{ width: `${pct}%` }}
        />
      </div>
      {showLabels && (
        <div className='flex justify-between mt-1'>
          <span className='text-xs text-muted-foreground'>Low</span>
          <span className='text-xs font-medium'>{QUALITY_TIERS[level]?.label} ({normalizedScore.toFixed(1)})</span>
          <span className='text-xs text-muted-foreground'>High</span>
        </div>
      )}
    </div>
  );
};

export default QualityBar;
